module.exports = __webpack_public_path__ + "images/emoji/capital_abcd.9310ecfaaec8016b7b36.png";